import type { EventSourceMessage } from '@microsoft/fetch-event-source';
import { notificationStatusReceived } from 'src/infra/stores/reducer/sseSlice';
import type { AppDispatch } from 'src/infra/stores/store';

/**
 * Handle SSE notification events
 * Processes notification status updates from the server
 */
export const handleNotificationEvent = (event: EventSourceMessage, dispatch: AppDispatch): void => {
  try {
    const data = JSON.parse(event.data);
    if (data) {
      dispatch(
        notificationStatusReceived({
          unreadCount: data.unreadCount ?? 1,
          lastUpdated: data.lastUpdated ?? new Date().toISOString(),
        })
      );
    }
  } catch (error) {
    console.error('❌ SSE: Error parsing notification event:', error);
  }
};
